import { render, staticRenderFns } from "./Commodity.vue?vue&type=template&id=3a33747b&scoped=true"
import script from "./Commodity.vue?vue&type=script&lang=js"
export * from "./Commodity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a33747b",
  null
  
)

export default component.exports